import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventPageComponent } from './components/event-page/event-page.component';
import { EventPageNavbarComponent } from './components/event-page-navbar/event-page-navbar.component';
import { EventPageHeaderTypeComponent } from './components/event-page-header-types/event-page-header-type/event-page-header-type.component';
import { EventPageHeaderType01Component } from './components/event-page-header-types/event-page-header-type01/event-page-header-type01.component';
import { EventPageHeaderType02Component } from './components/event-page-header-types/event-page-header-type02/event-page-header-type02.component';
import { EventPageHeaderType03Component } from './components/event-page-header-types/event-page-header-type03/event-page-header-type03.component';
import { EventPageHeaderType04Component } from './components/event-page-header-types/event-page-header-type04/event-page-header-type04.component';
import { EventPageHeaderType05Component } from './components/event-page-header-types/event-page-header-type05/event-page-header-type05.component';
import { EventPageBlockTextComponent } from './components/event-page-blocks/event-page-block-text/event-page-block-text.component';
import { EventPageBlockFaqComponent } from './components/event-page-blocks/event-page-block-faq/event-page-block-faq.component';
import { EventPageBlockSlidesComponent } from './components/event-page-blocks/event-page-block-slides/event-page-block-slides.component';
import { EventPageBlockCampaignComponent } from './components/event-page-blocks/event-page-block-campaign/event-page-block-campaign.component';
import { EventPageBlockSilentAuctionComponent } from './components/event-page-blocks/event-page-block-silent-auction/event-page-block-silent-auction.component';
import { EventPageBlockLiveAuctionComponent } from './components/event-page-blocks/event-page-block-live-auction/event-page-block-live-auction.component';
import { EventPageBlockVideoComponent } from './components/event-page-blocks/event-page-block-video/event-page-block-video.component';
import { EventPageBlockImageComponent } from './components/event-page-blocks/event-page-block-image/event-page-block-image.component';
import { EventPageSponsorsItemComponent } from './components/event-page-sponsors-item/event-page-sponsors-item.component';
import { EventPageOrganizationInfoComponent } from './components/event-page-organization-info/event-page-organization-info.component';

import { IconModule } from '../icon/icon.module';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { MatExpansionModule } from '@angular/material/expansion';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromEvent from '../event/features/event.reducer';
import {EventEffects} from '../event/features/event.effects';
import { EventPageEffects } from '../event-page/features/event-page.effects';
import { createCustomElement } from '@angular/elements';
import { ToastModule } from '../toast/toast.module';
import { DialogModule } from 'app/dialog/dialog.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { EventPageSponsorsComponent } from './components/event-page-sponsors/event-page-sponsors.component';
import { CoreModule } from '../core/core.module';

@NgModule({
    declarations: [
        EventPageComponent,
        EventPageNavbarComponent,
        EventPageHeaderTypeComponent,
        EventPageHeaderType01Component,
        EventPageHeaderType02Component,
        EventPageHeaderType03Component,
        EventPageHeaderType04Component,
        EventPageHeaderType05Component,
        EventPageBlockTextComponent,
        EventPageBlockFaqComponent,
        EventPageBlockSlidesComponent,
        EventPageBlockCampaignComponent,
        EventPageBlockSilentAuctionComponent,
        EventPageBlockLiveAuctionComponent,
        EventPageBlockVideoComponent,
        EventPageBlockImageComponent,
        EventPageSponsorsItemComponent,
        EventPageOrganizationInfoComponent,
        EventPageSponsorsComponent,
    ],
    imports: [
        CommonModule,
        IconModule,
        StoreModule.forRoot({}, {
            runtimeChecks: {
            strictStateImmutability: false,
            strictActionImmutability: false,
            },
        }),
        StoreModule.forFeature(fromEvent.eventFeatureKey, fromEvent.reducer),
        EffectsModule.forRoot([]),
        EffectsModule.forFeature([EventEffects, EventPageEffects]),
        MatExpansionModule,
        MdbDropdownModule,
        ToastModule,
        DialogModule,
        ClipboardModule,
        CoreModule
    ], 
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class EventPageModule {
    constructor(injector: Injector) {
      const EventPageElement = createCustomElement(EventPageComponent, {injector});
  
      try {
        customElements.define('paybee-event-page-element', EventPageElement);
      } catch(e) {}
    }
}